// Connector heartbeat → a status tone for a site. Shared by the Sites table and
// the site switcher so both read the same connectorStatus rows the same way.

import type { SemanticTone } from "@/app/console/ui";
import type { ConnectorStatusRow } from "@/app/queriesF2b";

// Agents heartbeat every few batches; >2 min silence means down.
export const CONNECTOR_STALE_AFTER_MS = 2 * 60_000;

export interface ConnectorState {
  tone: SemanticTone;
  label: string;
}

/** Match a connector site to an asset by id or name (site ids are free text). */
export function connectorFor(asset: { id: number; name: string }, rows: ReadonlyArray<ConnectorStatusRow>): ConnectorState {
  const name = asset.name.toLowerCase();
  const row = rows.find((r) => {
    const sid = r.siteId.toLowerCase();
    return sid === name || sid === String(asset.id) || sid.endsWith(`-${asset.id}`) || name.includes(sid) || sid.includes(name);
  });
  if (!row) return { tone: "neutral", label: "not enrolled" };
  if (!row.lastSeenAt) return { tone: "neutral", label: "never seen" };
  const age = Date.now() - new Date(row.lastSeenAt).getTime();
  return age > CONNECTOR_STALE_AFTER_MS ? { tone: "warn", label: "stale" } : { tone: "ok", label: "online" };
}
